import { render, staticRenderFns } from "./ShadowBox.vue?vue&type=template&id=79be798c&scoped=true&"
import script from "./ShadowBox.vue?vue&type=script&lang=js&"
export * from "./ShadowBox.vue?vue&type=script&lang=js&"
import style0 from "./ShadowBox.vue?vue&type=style&index=0&id=79be798c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79be798c",
  null
  
)

export default component.exports